import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

export const ToggleRadio = styled.input.attrs({
  type: "radio"
})`
  display: none;
`;

export const ToggleItemWrapper = styled.fieldset`
  border: 0;
  flex: 1 1 100%;
  padding: 0;

  && {
    margin: 0;

    &:not(:last-child) {
      margin-right: -1px;
    }
  }
`;

export const BaseTabWrapper = styled.label.attrs({
  role: "button",
  tabIndex: 0
})`
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
  background-color: #ffffff;
  border: 1px solid ${colors.foxGrey};
  box-sizing: border-box;
  color: ${colors.whaleGrey};
  display: inline-block;
  font: 14px/38px "Source Sans Pro", Helvetica, Arial, Geneva, sans-serif;
  height: 40px;
  line-height: 38px;
  text-align: center;
  width: 100%;

  * {
    box-sizing: inherit;
  }

  &:hover {
    background-color: ${colors.frostedGlass};
    cursor: pointer;
  }

  ${ToggleRadio}:checked + & {
    background-color: ${colors.glass};

    &:hover {
      background-color: ${colors.glass};
    }
  }

  ${ToggleRadio}:disabled + & {
    pointer-events: none;
    background-color: #ffffff;
    border-color: ${colors.foxGrey};
    color: ${colors.koalaGrey};
    cursor: not-allowed;
  }

  ${ToggleRadio}:checked:disabled + & {
    background-color: ${colors.rabbitGrey};
    cursor: not-allowed;
  }
`;
